import gql from 'graphql-tag';

export default gql`
  mutation publishArtwork($id: ID!) {
    publishArtwork(id: $id) {
      id
      status
    }
  }
`;
